import { Col, Flex } from "antd"
import { Button, Card, List, Title } from "../index"
import { useNavigate } from "react-router-dom"
import { getAppLanguage } from "configs/useInitializeApp"
import { useTranslation } from "react-i18next"

const ProgressFormLeftMenu = ({ title, progressItems, showBackButton = false, listItem }) => {
  const navigate = useNavigate()
  const language = getAppLanguage()
  const { t } = useTranslation()
  return (
    <Col span={7}>
      <Card
        title={
          <Flex gap={"small"} align={"center"}>
            {showBackButton && (
              <Button
                iconProps={{ size: "16px" }}
                size="small"
                shape="circle"
                type="muted"
                icon={language?.rtl ? "HiArrowRight" : "HiArrowLeft"}
                onClick={() => navigate(-1)}
              />
            )}
            <Title className={"mbe-0"} level={3}>
              {t(title)}
            </Title>
          </Flex>
        }
        bordered={false}
        bodyStyle={{ padding: 0, maxHeight: "calc(100vh - 252px)", overflowY: "auto" }}
      >
        <List dataSource={progressItems} listItemClassName="p-0" size="large" renderItem={listItem} />
      </Card>
    </Col>
  )
}

export default ProgressFormLeftMenu
